export const companies = [
  {
    name: "ABC-anglicky",
    phone: "+ 420 604 289 027",
    email: "chylkova.m@gmail.com",
    website: "www.abc-anglicky.cz",
    id: "Komenskeho",
    field: "school",
  },
  {
    name: "Mgr. Karel Kvasnica",
    phone: "+ 420 603 702 534",
    email: "advokat@kvasnica.cz",
    website: "www.kvasnica.cz",
    id: "Komenskeho",
    field: "gavel",
  },
  {
    name: "Charita Bohumín",
    subname: "ředitelství",
    phone: "+ 420 732 393 316",
    email: "info@bohumin.charita.cz",
    website: "www.bohumin.charita.cz",
    id: "Komenskeho",
    field: "volunteer_activism",
  },
  {
    name: "Tetovací studio Šimičko",
    phone: "+ 420 733 289 895",
    id: "Komenskeho",
    field: "ink_pen",
  },
  {
    name: "Manikúra a nehtový design",
    phone: "+ 420 792 258 497",
    id: "Komenskeho",
    field: "health_and_beauty",
  },
  {
    name: "Masážní studio NK",
    phone: "+ 420 734 816 496",
    id: "Komenskeho",
    field: "spa",
  },
  {
    name: "Pedikúra Relax",
    phone: "+ 420 605 513 259",
    id: "Komenskeho",
    field: "barefoot",
  },
  {
    name: "Kadeřnický salon Gabriela",
    phone: "+ 420 732 556 651",
    id: "Komenskeho",
    field: "content_cut",
  },
  {
    name: "Kosmetický salon Sandra",
    subname: "Pedikura",
    person: "Monika Pečová",
    phone: "+ 420 770 103 363",
    id: "Kostelni",
    field: "barefoot",
  },
  {
    name: "Kosmetický salon Sandra",
    subname: "Kosmetika",
    person: "Růžena Šotkovská",
    phone: "+ 420 603 878 088",
    id: "Kostelni",
    field: "face_retouching_natural",
  },
  {
    name: "Kosmetický salon Sandra",
    subname: "Kosmetika",
    person: "Andrea Marie Wajdová",
    phone: "+ 420 605 826 489",
    id: "Kostelni",
    field: "face_retouching_natural",
  },
  {
    name: "Kosmetický salon Sandra",
    subname: "Kadeřnictví",
    person: "Karla Uherková",
    phone: "+ 420 739 548 092",
    id: "Kostelni",
    field: "content_cut",
  },
];
